// Card / Lesson types. The "card" is a 词 (1–4 hanzi) — the atomic combat unit.
// Sentences/passages live on Lesson.passages and are only used by boss fights.

export type SemanticTag =
  | 'general'
  | 'animals'
  | 'food'
  | 'family'
  | 'numbers'
  | 'colors'
  | 'weather'
  | 'nature'
  | 'school'
  | 'body'
  | 'actions'
  | 'emotions';

export const SEMANTIC_TAGS: SemanticTag[] = [
  'general', 'animals', 'food', 'family', 'numbers', 'colors',
  'weather', 'nature', 'school', 'body', 'actions', 'emotions',
];

export interface Card {
  id: string;
  hanzi: string;            // Traditional preferred (per YCIS)
  hanziSimp?: string;       // Optional simplified variant
  pinyin: string;           // Tone-mark form: "māo", "hóng sè"
  pinyinNum: string;        // Tone-number form: "mao1", "hong2 se4" — used for ASR comparison
  english: string;          // Gloss
  tag: SemanticTag;
  audioRef?: string;        // Optional parent-recorded audio (blob URL / IndexedDB key)
  lessonId: string;         // The lesson/chapter this card belongs to
  createdAt: number;
}

export interface Lesson {
  id: string;
  title: string;            // "Week 3 — Animals" or whatever the parent types
  source: 'paste' | 'ocr' | 'starter';
  passages: string[];       // Optional sentences/paragraphs (for boss fights)
  zoneTheme: SemanticTag;   // Drives monster art selection
  createdAt: number;
}
